import React, {useState} from "react";
import {Link, useHistory, useLocation} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import UIDatePicker from "components/datepicker";
import useToggleState from 'components/hooks/useToggleState';
import ModalPopup from 'components/modal/';
import Breadcrumb from 'layouts/admin/Breadcrumb';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import StringUtil from "../../../../utils/StringUtil";
import CommonUtil from "../../../../utils/CommonUtil";
import UIUtils from "../../../../utils/UIUtils";

function ContentsContainer() {
	//테스트용 서버 url
	const serverUrl = 'http://dev.fund.win-win.or.kr/';
	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const history = useHistory();

	const [bizCd,setBizCd] = useState('');
	const [bizNo,setBizNo] = useState('');
	const [bizNm,setBizNm] = useState('');
	const [donNo,setDonNo] = useState('');
	const [donNoFmt,setDonNoFmt] = useState('');
	const [corpNm,setCorpNm] = useState('');
	const [receNo,setReceNo] = useState('');
	const [receSts,setReceSts] = useState('');
	const [personNm,setPersonNm] = useState('');
	const [deptNm,setDeptNm] = useState('');
	const [donReqDate,setDonReqDate] = useState('');
	const [donReqAmt,setDonReqAmt] = useState('');
	const [bankCd,setBankCd] = useState('');
	const [acctNoDes,setAcctNoDes] = useState('');
	const [receAmt,setReceAmt] = useState('');
	const [lastReceDate,setLastReceDate] = useState('');
	const [publishType,setPublishType] = useState('');
	const [receYear,setReceYear] = useState('');
	const [REC2, setREC2] = useState<any>([]);
	const [REC3, setREC3] = useState<any>([]);
	const [receNoList, setReceNoList] = useState<any>([]);
	const [issStateList, setIssStateList] = useState<any>([]);
	const [donDateModYn,setDonDateModYn] = useState('');
	const [reqApprYn,setReqApprYn] = useState('');
	
	interface rec2Item {
		DON_RECE_STS:string
		,DON_RECE_DATE:string
		,DON_RECE_DATE_STR:string
		,RN:string
		,DON_RECE_NO:string
		,DON_RECE_AMT:string
		,DON_RECE_USE_YN:string
	}
	interface rec2Items extends Array<rec2Item>{};

	function rece_regist(){
		let dataToSend = {vDON_NO : donNo, vAll_PARAM:receivedData.vAll_PARAM};
		
		if(reqApprYn != 'Y'){
			UIUtils.alert('출연신청서가 제출되지 않았습니다.').then();
			return false;
		}
		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './adm3301',
			state: { data: dataToSend }
		});
	}

	async function rece_cancel(){
		if(receSts != '발급'){
			UIUtils.alert('발급된 기부금영수증내역이 없습니다.').then();
			return false;
		}
		if(receYear != (new Date().getFullYear()+'')){
			UIUtils.alert('당해년도 발급된 기부영수증만 취소 가능합니다.').then();
			return false;
		}

		if(await UIUtils.confirm('기부금영수증내역을 취소하시겠습니까?')){
			let url = 'adm_3300_hando_chk';
			let param = {
				 "BIZ_CD": bizCd
				,"BIZ_NO": bizNo
			};


			//파라미터 전송
			const response:any = await CommonUtil.execute({
				url: url,
				data: param
			}).then((response: any) => {
				if(Number(receAmt) <= Number(response.REMAIN_DON_AMT)){

						let param = {
							"DON_NO": receivedData.vDON_NO,
							'YEAR' : new Date().getFullYear()+'',
							 "BIZ_CD": bizCd,
							 "BIZ_NO": bizNo
						};

						const response:any = CommonUtil.execute({
							url:'adm_3300_cancel',
							data: param
						})

						UIUtils.alert('취소 되었습니다.').then();
						// 다른 페이지로 이동하면서 데이터 전달
						history.push({
							pathname: './adm3200',
							state: { data: receivedData }
						});

				}else if(Number(receAmt) > Number(response.REMAIN_DON_AMT)){
					UIUtils.alert('취소가능한 출연금액이 부족합니다.').then();
					return 'amt'
				}
			}).catch((error) => {
				CommonUtil.showAxiosError(error);
				return;
			});
		}
	}

	function dateLpad(num){
		if(num.toString().length == 1){
			num = "0"+num;
		}

		return num;
	}

	function dateToStr(dateText) {

		if(dateText == null) return '';

		if(/^(-?)[0-9]+$/.test(dateText)){
			dateText = Number(dateText);
		}
		let date = new Date(dateText);
		let week = new Array('일', '월', '화', '수', '목', '금', '토');


		let year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();
		let dayName = week[date.getDay()];

		return year+'-'+dateLpad(month)+'-'+dateLpad(day)+'('+dayName+')';
	}

	async function initCall(){
		console.log(receivedData)
		let param = {
			"DON_NO": receivedData.vDON_NO
		};

		const response:any = await CommonUtil.execute({
			url:'adm_3300',
			data: param
		})

		const result = response;
		console.log(result)
		setReceSts(result.RECE_STS);
		setDonNo(result.DON_NO);
		setDonNoFmt((result.DON_NO).substr(0, 3)+"-"+(result.DON_NO).substr(3,4)+"-"+(result.DON_NO).substr(7,3));
		setCorpNm(result.CORP_NM);
		setBizNm(result.BIZ_NM);
		setBizNo(result.BIZ_NO);
		setBizCd(result.BIZ_CD);
		setDonReqDate(result.DON_REQ_DATE);
		setDonReqAmt(result.DON_REQ_AMT);
		//setBankCd(result.BANK_CD);
		setBankCd('하나은행');
		setAcctNoDes(result.ACCT_NO_DES);
		setReceAmt(result.RECE_AMT);
		setLastReceDate(result.LAST_RECE_DATE);
		setReceNo(result.RECE_NO);
		setDeptNm(result.DEPT_NM);
		setPersonNm(result.PERSON_NM);
		let pType = '';
		if(result.RECE_STS == '발급'){
			pType = result.PUBLISH_TYPE == '1' ? '단건으로 발행' : '다건으로 발행';
		}
		setPublishType(pType);

		const rec2List = result.REC2;
		setREC2(rec2List);

		let issStateArr:rec2Items = [];
		if(rec2List.length !== 0) {
			setReceYear(new Date(rec2List[0].DON_RECE_DATE).getFullYear()+'');
			
			let newRec2List = JSON.parse(JSON.stringify(rec2List));
			for(const rData of newRec2List) {
				let donReceStsVal = '';
				if('발급' === rData.DON_RECE_STS) donReceStsVal = '1';
				else if('취소' === rData.DON_RECE_STS) donReceStsVal = '2';
				rData.DON_RECE_STS = donReceStsVal;
				rData.DON_RECE_DATE_STR = rData.DON_RECE_DATE.replace(/[^\d]/ig, '');
			}
			newRec2List.some((item:rec2Item) => {
				if('1' === item.DON_RECE_STS) issStateArr.push(item);
				return '2' === item.DON_RECE_STS;
			});
		}
		setIssStateList(issStateArr);

		setREC3(result.REC3);
		//setCorpInfo(result);
		setReceNoList(result.RECE_NO.split(','))

		// @ts-ignore
		if(typeof result == 'undefined'){
			alert('data is not loaded!!!')
			return;
		}
		setDonDateModYn(result.DON_DATE_MOD_YN);
		setReqApprYn(result.REQ_APPR_YN);
	};

	const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		let val = event.target.value;
		let evtNo = Number(event.target.name.replace('rd-',''));
		let newList = [...issStateList];
		newList[evtNo].DON_RECE_USE_YN = val;
		setIssStateList(newList);
	};

	const issStateUseYnSave = async () => {
		if(await UIUtils.confirm('저장 하시겠습니까?')) {
			let param = {
				"DON_NO": donNo,
				"ISS_STATE_LIST": issStateList
			};

			const response:any = await CommonUtil.execute({
				url:'adm_3300_update',
				data: param
			}).then((response: any) => {
				if(response != null && response.RESULT_MSG === '성공') {
					UIUtils.alert('정상처리되었습니다.').then();
					initCall();
				}else {
					UIUtils.alert('저장에 실패하였습니다.').then();
				}
				return;
			}).catch((error) => {
				CommonUtil.showAxiosError(error);
				return;
			});
		}
	};

	React.useEffect(() => {
		initCall();
	}, []);

	function moveBack(){
		//window.history.back();
		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './adm3200',
			state: { data: JSON.parse(receivedData.vAll_PARAM) }
		});
	}

	return (
		<PageContainer>
			<LayoutAside />
			<div className="fww-con">
				<Breadcrumb gnbIdx={2} lnbD1Idx={1} />
				<main className="fww-main">
					<h1 className="tx tx-hd2">기부금영수증 상세</h1>
					<h3 className="section-title mb15">출연정보</h3>
					<form className="fo fo-col2 mb30" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">출연번호</p>
								<div className="fo-value">{donNoFmt}</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">출연기업</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={corpNm} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">출연사업</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={bizNm} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">출연신청일</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={dateToStr(donReqDate)} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">출연신청금액(원)</p>
								<div className="fo-value">
								<UIInput className={'tf tf-md ta-right w100p'} value={StringUtil.formatNumber(Number(donReqAmt)) || "0"} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">입금은행</p>
								<div className="fo-value">
								<UIInput className={'tf tf-md w100p'} value={bankCd} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">계좌번호</p>
								<div className="fo-value">
								<UIInput className={'tf tf-md w100p'} value={acctNoDes} placeholder={''} readOnly={true} />
								</div>
							</div>
							{/*<div className="fo-item">
								<p className="fo-key">누적 입금금액</p>
								<div className="fo-value">
								<UIInput className={'tf tf-md ta-right w100p'} value={StringUtil.formatNumber(Number(receAmt)) || "0"} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">입금일자</p>
								<div className="fo-value">
								<UIInput className={'tf tf-md ta-right w100p'} value={lastReceDate} placeholder={''} readOnly={true} />
								</div>
							</div>*/}

						</div>
					</form>
					<h3 className="section-title mb15">출연기업 가상계좌 입금내역</h3>
					<form className="fo fo-col2 mb30" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">발급금액</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md ta-right w100p'} value={StringUtil.formatNumber(Number(receAmt)) || "0"} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">발행방법</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={publishType} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">발급상태</p>
								<div className="fo-value">
									{receSts}
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">재단발행부서</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={deptNm} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">재단발행담당자</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={personNm} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">발급일</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={lastReceDate} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">발급일 지정여부</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={donDateModYn} placeholder={''} readOnly={true} />
								</div>
							</div>
						</div>
					</form>
					<section className="fund-section">
						<form name="" action="" method="">
							<div className="tb tb-narrow">
								<table>
									<caption></caption>
									<colgroup>
										<col width="60px" />
										<col />
										<col />
										<col />
										<col />
										<col />
									</colgroup>
									<thead>
									<tr>
										<th scope="col">NO</th>
										<th scope="col">거래일시</th>
										<th scope="col">계좌구분</th>
										<th scope="col">가상계좌</th>
										<th scope="col">입금액(원)</th>
										<th scope="col">입금의뢰인</th>
									</tr>
									</thead>
									<tbody>
									{REC3.length != 0? REC3.map((rec, index) => (
											<tr key={index}>
												<td>{index+1}</td>
												<td>{rec.ACCT_DATE}</td>
												<td>{'출연계좌'}</td>
												<td>{rec.VACCT_NO}</td>
												<td>{StringUtil.formatNumber(Number(rec.TX_AMT)) || "0"}</td>
												<td>{rec.JEOKYO}</td>
											</tr>
										))
									: <tr><td colSpan={6}>데이터가 없습니다.</td></tr>}
									</tbody>
								</table>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<div className="hz-root hz-sb mb8">
							<div className="hz-root hz-gap5">
								<h3 className="section-title mb8">기부금영수증 발급현황</h3>
							</div>
							{issStateList.length !== 0 &&
								<Button color='gray-o' size="sm" onClick={() => issStateUseYnSave()}>사용여부 저장</Button>
							}
						</div>
						<form name="" action="" method="">
							<div className="tb tb-narrow">
								<table>
									<caption></caption>
									<colgroup>
										<col width="60px" />
										<col />
										<col />
										<col />
										<col />
									</colgroup>
									<thead>
									<tr>
										<th scope="col">NO</th>
										<th scope="col">기부금영수증번호</th>
										<th scope="col">금액</th>
										<th scope="col">발급일시</th>
										<th scope="col">사용여부</th>
									</tr>
									</thead>
									<tbody>
									{issStateList.length !== 0 ? issStateList.map((rec, index) => (
											<tr key={index}>
												<td>{index + 1}</td>
												<td>{rec.DON_RECE_NO}</td>
												<td>{StringUtil.formatNumber(Number(rec.DON_RECE_AMT)) || "0"}</td>
												<td>{rec.DON_RECE_DATE}</td>
												<td>
													<div className="hz-root hz-gap24 h36 inflex">
														<label htmlFor={"rd-"+index+"-1"} className="ip-rd-label">
															<input name={"rd-"+index} id={"rd-"+index+"-1"} className="ip-rd" type="radio" value='Y' checked={rec.DON_RECE_USE_YN === 'Y'} onChange={handleOptionChange}/>
															<span className="check"></span>
															<span className="txt">사용</span>
														</label>
														<label htmlFor={"rd-"+index+"-2"} className="ip-rd-label">
															<input name={"rd-"+index} id={"rd-"+index+"-2"} className="ip-rd" type="radio" value='N' checked={rec.DON_RECE_USE_YN === 'N'} onChange={handleOptionChange}/>
															<span className="check"></span>
															<span className="txt">불가</span>
														</label>
													</div>
												</td>
											</tr>
										))
										: <tr><td colSpan={5}>데이터가 없습니다.</td></tr>}
									</tbody>
								</table>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">기부금영수증 발급내역</h3>
						<form name="" action="" method="">
							<div className="tb tb-narrow">
								<table>
									<caption></caption>
									<colgroup>
										<col width="60px" />
										<col />
										<col />
										<col />
										<col />
									</colgroup>
									<thead>
									<tr>
										<th scope="col">NO</th>
										<th scope="col">기부금영수증번호</th>
										<th scope="col">금액</th>
										<th scope="col">구분</th>
										<th scope="col">신청일시</th>
									</tr>
									</thead>
									<tbody>
									{REC2.length != 0 ? REC2.map((rec, index) => (
											<tr key={index}>
												<td>{rec.RN}</td>
												<td>{rec.DON_RECE_NO}</td>
												<td>{StringUtil.formatNumber(Number(rec.DON_RECE_AMT)) || "0"}</td>
												<td>{rec.DON_RECE_STS}</td>
												<td>{rec.DON_RECE_DATE}</td>
											</tr>
										))
										: <tr><td colSpan={5}>데이터가 없습니다.</td></tr>}
									</tbody>
								</table>
							</div>
						</form>
					</section>
					<div className="hz-root hz-right hz-gap10 mt30">
						{ receSts != '발급' && <Button color="pri-o" size="sm" onClick={() => rece_regist()}>기부금영수증등록</Button> }
						{ receSts == '발급' && <Button color="gray-o" size="sm" onClick={() => rece_cancel()}>기부금영수증취소</Button> }
						<Button color="gray-o" size="sm" onClick={() => moveBack()}>목록</Button>
					</div>
				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;